import React, { useEffect, useState } from 'react';

const ScrollToTopButton: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [scrollPercent, setScrollPercent] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const percent = docHeight > 0 ? Math.round((scrollTop / docHeight) * 100) : 0;
      setScrollPercent(percent);
      setVisible(scrollTop > 0);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      onClick={scrollToTop}
      aria-label="Scroll to top"
      className={`fixed bottom-6 right-6 z-50 p-0.5 rounded-full border border-gray-200 dark:border-gray-700 shadow-lg transition-opacity duration-300 focus:outline-none focus:ring-2 focus:ring-primary group ${
        visible ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
      }`}
      style={{ background: 'none' }}
    >
      <span className="flex items-center justify-center w-12 h-12 bg-white dark:bg-gray-900 rounded-full group-hover:bg-theme_light dark:group-hover:bg-gray-800 transition-colors duration-300 text-lg font-bold select-none">
        {scrollPercent === 100 ? (
          <svg
            className="w-6 h-6 text-primary group-hover:text-theme_dark transition-colors duration-300"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
          </svg>
        ) : (
          <span className="font-bold text-lg bg-gradient-to-r from-primary to-secondary text-transparent bg-clip-text">{scrollPercent}%</span>
        )}
      </span>
    </button>
  );
};

export default ScrollToTopButton; 